/**
 * Role-based access control (RBAC) roles shared between client, admin, and
 * server. Unified across VEGAAHI's own admin dashboard and the HR/EMS
 * modules ported in from Office_project — one People collection, one login,
 * one role list, rather than two separate identity systems. `editor` is the
 * one VEGAAHI-only role (admin-dashboard content/leads access) and sits
 * outside the HR hierarchy below; see `roleHierarchy.ts` for who can grant
 * what.
 *
 * There is no `super_admin` — `admin` is the top of the ladder. The very
 * first admin account comes from `seed.ts` (a direct repository write, not
 * the role-assignment-guarded Employees flow), the same way it always has.
 */
export const ROLES = {
  ADMIN: 'admin',
  MD: 'md',
  HR_MANAGER: 'hr_manager',
  HR_STAFF: 'hr_staff',
  MANAGER: 'manager',
  EMPLOYEE: 'employee',
  EDITOR: 'editor',
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

export const ALL_ROLES = Object.values(ROLES) as Role[];

/** Roles permitted to sign in to the admin dashboard's Leads/Applications area. */
export const ADMIN_DASHBOARD_ROLES: Role[] = [ROLES.ADMIN, ROLES.EDITOR];
